<template>
    <div>

        <headline v-if="!loading">
            <span>{{ cat.name }}</span>
            <template v-slot:more>
                <bookable-booking-create :category="cat" class="mr-2" @created="load"></bookable-booking-create>
                <bookable-create :category="cat" class="mr-2" @created="load"></bookable-create>
                <bookable-category-edit :category="cat" class="mr-2"></bookable-category-edit>
                <button-secondary @click="download">
                    <template slot="icon"><i class="fa fa-download"></i></template>
                    Daten exportieren
                </button-secondary>
            </template>
        </headline>

        <loading v-show="loading"></loading>

        <manage-pending-bookings :category-id="category" ref="pending_bookings"></manage-pending-bookings>

        <div v-if="!loading">

            <tailwind-table :has_filter=true :header="['Etage', cat.name, 'Aktuelle Buchungen', 'Foto verfügbar', '']"
                            v-show="items.length > 0">
                <template slot="filter">
                    <floor-select class="px-2" v-model="floor" :filter="true"></floor-select>
                </template>
                <tr v-for="(item,i) in filteredItems" :key="item.id" :class="{'bg-gray-50': i % 2}">
                    <td class="px-6 py-3">
                        <span v-if="item.floor">{{ item.floor.name }}</span>
                    </td>
                    <td class="px-6 py-3">
                        <a :href="`/admin/pages/bookables/${item.id}`">
                            {{ item.name }}
                        </a>
                    </td>
                    <td class="px-6 py-3">
                        <a :href="`/admin/pages/bookables/${item.id}`">
                            {{ item.bookings.length }}
                            <span v-show="item.bookings.length === 1">
                                Buchung
                            </span>
                            <span v-show="item.bookings.length !== 1">
                                Buchungen
                            </span>
                        </a>
                    </td>
                    <td class="px-6 py-3">
                        <span v-if="item.image">Ja</span>
                        <span v-if="!item.image">Nein</span>
                    </td>
                    <td class="px-6 py-3 flex justify-end">
                        <a :href="`/admin/pages/bookables/${item.id}`" class="mr-2">
                            <button-white>Anzeigen</button-white>
                        </a>
                        <bookable-edit :item="item" @updated="load"></bookable-edit>
                    </td>
                </tr>
            </tailwind-table>

            <div v-if="items.length === 0 && !loading">
                Keine {{ cat.name }} gefunden.
            </div>

        </div>

    </div>
</template>

<script>
import Headline from "../components/UI/Headline";
import Loading from "../components/UI/Loading";
import ConferenceRoomCreate from "../components/ConferenceRoomCreate";
import TailwindTable from "../components/UI/TailwindTable";
import Card from "../components/UI/Card";
import ConferenceRoomEdit from "../components/ConferenceRoomEdit";
import ConferenceRoomBookingCreate from "../components/ConferenceRoomBookingCreate";
import ButtonSecondary from "../components/UI/ButtonSecondary";
import ConfirmDialog from "../components/UI/ConfirmDialog";
import FullCard from "../components/UI/FullCard";
import CardFullInvisible from "../components/UI/CardFullInvisible";
import ButtonWhite from "../components/UI/ButtonWhite";
import ButtonPrimary from "../components/UI/ButtonPrimary";
import sortBy from "lodash/sortBy";
import ConferenceRoomBooking from "../components/ConferenceRoomBooking";
import ButtonDelete from "../components/UI/ButtonDelete";
import BookableCreate from "../components/Bookable/BookableCreate";
import BookableBookingCreate from "../components/Bookable/BookableBookingCreate";
import BookableEdit from "../components/Bookable/BookableEdit";
import FloorSelect from "../components/FloorSelect";
import AlertDialog from "../components/UI/AlertDialog.vue";
import ManagePendingBookings from "../components/ManagePendingBookings";
import BookableCategoryEdit from "../components/Bookable/BookableCategoryEdit";

export default {
    name: "BookableCategory",

    props: ['category'],

    components: {
        ManagePendingBookings,
        AlertDialog,
        FloorSelect,
        BookableEdit,
        BookableBookingCreate,
        BookableCreate,
        ButtonDelete,
        ConferenceRoomBooking,
        ButtonPrimary,
        ButtonWhite,
        CardFullInvisible,
        FullCard,
        ConfirmDialog,
        ButtonSecondary,
        ConferenceRoomBookingCreate,
        ConferenceRoomEdit,
        Card,
        TailwindTable,
        ConferenceRoomCreate,
        Loading,
        Headline,
        BookableCategoryEdit
    },

    data: () => ({
        items: [],
        loading: true,
        categories: [],
        floor: null,
    }),

    mounted() {
        this.load();
    },

    filters: {
        time(val) {
            return val.substring(11, 5);
        },
        date(val) {
            let [y, m, d] = val.substring(0, 10).split('-');
            return `${d}.${m}.${y}`;
        }
    },

    computed: {
        filteredItems() {
            return this.items
                .filter(d => {
                    if (!this.floor) {
                        return true;
                    }

                    if (!d.floor) {
                        return false;
                    }

                    return d.floor.id === this.floor;
                });
        },
        cat() {
            return this.categories.find(c => c.id === this.category);
        },
    },

    methods: {
        load() {
            this.$refs.pending_bookings.load();
            this.loading = true;
            window.axios.get('/admin/bookables').then(response => {
                this.items = response.data.data.filter(item => {
                    return item.bookable_category_id === this.category;
                });
                this.categories = response.data.categories;
                this.loading = false;
            }).catch(error => {
                this.$root.$emit('error', error);
            });

        },
        sortBookings(bookings) {
            return sortBy(bookings, 'start');
        },
        download() {
            window.open('/admin/bookable_categories/' + this.category + '/export');
        }
    }
}
</script>

<style scoped>

</style>
